import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable()
export class MenuService {
  menuItems: Array<any>;

  /** Emite el array de ítems del menú cada vez que se actualiza */
  private menuItems$: BehaviorSubject<Array<any>> = new BehaviorSubject<Array<any>>([]);

  constructor() {
    this.menuItems = [];
  }

  addMenu(
    items: Array<{
      text: string;
      heading?: boolean;
      link?: string; // internal route links
      elink?: string; // used only for external links
      target?: string; // anchor target="_blank|_self|_parent|_top|framename"
      icon?: string;
      alert?: string;
      submenu?: Array<any>;
    }>
  ) {
    /*   items.forEach((item) => {
      this.menuItems.push(item);
    }); */
  }

  push(value) {
    this.menuItems = [...value];
    this.menuItems$.next(this.menuItems);
  }

  getMenu() {
    return this.menuItems;
  }

  /** Observable que emite el menú actualizado */
  getMenu$(): Observable<Array<any>> {
    return this.menuItems$.asObservable();
  }
}
